export function sortByDate<T>(key: keyof T, type: 'DESC' | 'ASC'): (a:T, b:T) => number {
  return function(a:T, b:T): number {
    const dates = type === 'DESC' ? [b, a] : [a, b];
    return new Date(dates[0][key] as string).getTime() - new Date(dates[1][key] as string).getTime();
  };
}
